import React from 'react';
import Grid from '../components/Core/Grid';
import WindowBody from '../components/Window/WindowBody';
import WindowFooter from '../components/Window/WindowFooter';
import { UiButton } from '../components/UiButton';

export default function LogComunicacaoGridViewer(props: any) {
    const data = props.data || {};

    const initialFilter = [
        { name: 'lc_referencia_tipo', value: data.referenciaTipo, type: 'text',   operator: '=' },
        { name: 'lc_referencia_id',   value: data.referenciaId,   type: 'number', operator: '=' },
    ];

    return (
        <>
            <WindowBody noPadding>
                <Grid
                    router="logcomunicacao"
                    initialFilter={initialFilter}
                    hideDefaultActions
                />
            </WindowBody>
            <WindowFooter>
                <UiButton variant="secondary" onClick={props.triggerClose}>Fechar</UiButton>
            </WindowFooter>
        </>
    );
}
